import Device from '../../../../../constants/deviceSizes';
import { small } from '../../../../../constants/fonts';
import { appConfig } from '../../../../../config/customization';

export default {
  account: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  form: {
    display: 'flex',
    alignItems: 'flex',
    justifyContent: 'stretch',
    flexDirection: 'column',
    padding: '10px 40px 10px',
    [Device.tablet_mobile]: {
      padding: 20
    }
  },
  submit: {
    width: '75%',
    alignSelf: 'center',
    textTransform: 'uppercase',
    marginTop: 20
  },
  termsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '25vh',
    overflowY: 'scroll',
    border: `1px solid ${appConfig.colors.lightGray}`,
    backgroundColor: appConfig.colors.lightGray,
    width: '100%',
    paddingRight: 5
  },
  terms: {
    fontSize: small,
    textAlign: 'center'
  },
  termsAndConditionsButton: {
    width: '100%'
  }
};
